import { useApiGet, useApiLoading } from 'react-reqq-lite';
import { useCallback, useEffect } from 'react';
import { ITEM, LIST, PAGER } from './constants';
import {
  createCategory,
  deleteCategory,
  listCategory,
  updateCategory,
} from './actions';

export const useCategoryList = (params) => {
  const isLoading = useApiLoading(LIST, 'get');
  const meta = useApiGet(PAGER, {});
  const list = useApiGet(LIST, []);
  useEffect(() => {
    listCategory(params);
  }, [params]);
  return [isLoading, list, meta];
};

export const useCreateCategory = () => {
  const isLoading = useApiLoading(ITEM, 'post');
  const submit = useCallback((payload, onSuccess) => {
    createCategory(payload, onSuccess);
  }, []);
  return [isLoading, submit];
};

export const useUpdateCategory = () => {
  const isLoading = useApiLoading(ITEM, 'put');
  const submit = useCallback((id, payload, onSuccess) => {
    updateCategory(id, payload, onSuccess);
  }, []);
  return [isLoading, submit];
};

export const useDeleteCategory = () => {
  const isLoading = useApiLoading(ITEM, 'remove');
  const submit = useCallback((id, onSuccess) => {
    deleteCategory(id, onSuccess);
  }, []);
  return [isLoading, submit];
};
